// exclude-from-index
import 'rc-slider/assets/index.css';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RcSlider from 'rc-slider';
import { railStyle, trackStyle, handleStyle } from './Slider.styles.js';

const Range = RcSlider;

class Slider extends PureComponent {
  static propTypes = {
    /**
     * Sets the range handles at the given values when rendering a range slider
     */
    defaultRangeValue: PropTypes.arrayOf(PropTypes.number),
    /**
     * Sets the slider handle at the given value when rendering a basic slider
     */
    defaultSlideValue: PropTypes.number,
    /**
     * If true, it renders a range slider
     */
    isRange: PropTypes.bool
  };

  static defaultProps = {
    defaultRangeValue: [0, 0],
    defaultSlideValue: undefined,
    isRange: false
  };

  render() {
    const { defaultRangeValue, defaultSlideValue, isRange, disabled = false } = this.props;

    return (
      <div style={{ width: '100%', padding: '2px 9px' }}>
        {isRange ? (
          <Range
            {...this.props}
            range={isRange}
            allowCross={false}
            defaultValue={defaultRangeValue}
            handleStyle={disabled ? handleStyle.disabled : handleStyle.default}
            railStyle={disabled ? railStyle.disabled : railStyle.default}
            style={{ background: 'transparent' }}
            trackStyle={disabled ? trackStyle.disabled : trackStyle.default}
          />
        ) : (
          <RcSlider
            {...this.props}
            defaultValue={defaultSlideValue}
            handleStyle={disabled ? handleStyle.disabled : handleStyle.default}
            railStyle={disabled ? railStyle.disabled : railStyle.default}
            style={{ background: 'transparent' }}
            trackStyle={disabled ? trackStyle.disabled : trackStyle.default}
          />
        )}
      </div>
    );
  }
}

export default Slider;
